<div class="notification-item-container unread-noti" *ngIf="!properties.read">
    <ng-container *ngTemplateOutlet="notiItem"></ng-container>
</div>

<div class="notification-item-container" *ngIf="properties.read">
    <ng-container *ngTemplateOutlet="notiItem"></ng-container>
</div>

<ng-template #notiItem>
    <div class="noti-module">
        <app-button [properties]="{function:'dashboard'}" *ngIf="properties.moduleId == 1"></app-button>
        <app-button [properties]="{function:'reference'}" *ngIf="properties.moduleId == 2"></app-button>
    </div>

    <div class="noti-detail-container">
        <h6 *ngIf="properties.title.length > 50" tooltipPosition="left" pTooltip={{properties.title}}
            tooltipStyleClass="custom-noti-tooltip">{{properties.title.substring(0,50)}}...</h6>
        <h6 *ngIf="properties.title.length <= 50">{{properties.title}}</h6>

        <p *ngIf="properties.content.length > 50" tooltipPosition="left" pTooltip={{properties.content}}
            tooltipStyleClass="custom-noti-tooltip">{{properties.content.substring(0,50)}}...</p>
        <p *ngIf="properties.content.length <= 50">{{properties.content}}</p>

        <div *ngIf="properties.status != undefined">
            <p *ngIf="properties.status.length > 50" tooltipPosition="left" pTooltip={{properties.status}}
                tooltipStyleClass="custom-noti-tooltip">{{properties.status.substring(0,50)}}...</p>
            <p *ngIf="properties.status.length <= 50">{{properties.status}}</p>
        </div>

        <p>{{properties.date}} / {{properties.time}}</p>
        <a href="{{properties.url}}">Click Here</a>
        <p style="display: inline-block;margin-left: 15px !important;">{{calculateTimePassed(properties.dateFull)}} ago
        </p>
    </div>
</ng-template>